import { render, staticRenderFns } from "./dberd.vue?vue&type=template&id=6bf14f63"
import script from "./dberd.vue?vue&type=script&lang=js"
export * from "./dberd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf14f63')) {
      api.createRecord('6bf14f63', component.options)
    } else {
      api.reload('6bf14f63', component.options)
    }
    module.hot.accept("./dberd.vue?vue&type=template&id=6bf14f63", function () {
      api.rerender('6bf14f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/devtool/dberd.vue"
export default component.exports